// extracted by mini-css-extract-plugin
module.exports = {"logo":"Footer_logo__3iOMy","terms":"Footer_terms__2Nexu","notes":"Footer_notes__1oJAT","cardStyling":"Footer_cardStyling__3JMOj"};